"use client";

import { Combobox, SelectProps } from "@/components/combo-box";
import { ERoundingMode } from "@/features/policies/salary-scales";
import { convertEnumToDropdownItems } from "@/lib/utils";
import { ComboboxOptions, IDropdown } from "@/types/common-type";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

export function RoundingModeSelect({
  selected,
  mode = "single",
  disabled = false,
  onChange,
}: SelectProps) {
  const t = useTranslations("component-title");
  const [roundingModes, setRoundingModes] = useState<ComboboxOptions[]>([]);

  useEffect(() => {
    const rmItems = convertEnumToDropdownItems(ERoundingMode);
    const items: ComboboxOptions[] =
      rmItems?.map((rp: IDropdown) => ({
        label: rp.name,
        value: rp.id.toString(),
      })) || [];
    setRoundingModes(items);
  }, []);

  return (
    <Combobox
      options={roundingModes}
      mode={mode}
      placeholder={t("rounding-mode-select")}
      disabled={disabled}
      selected={selected}
      onChange={onChange}
    />
  );
}
